import { useEffect } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';

import { useTitleStore } from '@/store/headerTitle';

export default function useControlTitle() {
  const { hideTitle, setHideTitle } = useTitleStore();
  const { isIntersecting, ref } = useIntersectionObserver({
    initialIsIntersecting: true,
    threshold: 0,
  });

  useEffect(() => {
    setHideTitle(isIntersecting);
  }, [isIntersecting]);

  return { hideTitle, ref };
}
